// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"5698067c","171":"1ed06486","374":"59232377","426":"ec786e0a","507":"f789003b","732":"69567da7","763":"0b311987","845":"fe2fc78a"}[chunkId] + ".chunk.js";
};